<template>
  <div>
    <!-- 사인 -->
    <table v-if="isPrint">
      <tbody>
        <tr>
          <td rowspan="2" class="title">물질 안전·보건자료 게시</td>
          <td rowspan="2" class="titleCell bordered" style="width: 33px">결<br /><br /><br />재</td>
          <td class="titleCell signTitle bordered">담당자</td>
        </tr>
        <tr>
          <td class="signBody bordered">
            <div style="width: 125px; height: 80px">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 유해·위험·화학물질 목록</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-x-6 gap-y-4 mt-10 mb-12">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.checkList1" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> CAS No. (관리대상 유해물질의 종류)</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-x-6 gap-y-4 mt-10 mb-12">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.checkList2" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    목록-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 안전보건표지의 용도 및 사용장소</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-x-6 gap-y-4 mt-10 mb-12">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div v-for="(inspection, indexRows) in form.inspectList" v-bind:key="inspection.id">
      <table-inspect-column7
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        v-model="inspection.list"
        :is-note="true"
        table-header-column2="종류"
        table-header-title="용도 및 사용 장소"
        table-header-yes="작성"
        table-header-no="미작성"
        table-header-na="해당없음"
        table-header-note="사용장소"
        table-sub-width="14%"
        table-note-width="30%"
        v-if="inspection.check"
        @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
        @update-note="
          (param1, param2) => {
            updateListNote(indexRows, param1, param2);
          }
        "
      />
    </div>

    <!-- 기타 의견 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기타 의견</h5>
      <div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputA_1 }}</p>
        <ml-textarea :readonly="board.readonly" v-else v-model="form.inputA_1" class="w-full" rows="5" />
      </div>
    </div>

    <!-- 확인자 -->
    <div v-if="!isPrint" class="mt-28px">
      <div>
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>담당자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectColumn7 from "@/components/TableInspectColumn7";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    TableInspectColumn7,
    FieldSelectModule,
    FileUploadModule,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        typeTitleList1: [],
        typeTitleList2: [],
        checkList1: [
          { label: "메틸알코올", check: false },
          { label: "N,N-디테밀아세트아미드", check: false },
          { label: "디메틸포름아미드", check: false },
          { label: "퍼클로로에틸렌", check: false },
          { label: "아크릴로니트릴", check: false },
          { label: "트리클로로에틸렌", check: false },
          { label: "6가크롬화합물", check: false },
          { label: "카드뮴", check: false },
          { label: "납", check: false },
          { label: "포름알데히드", check: false },
          { label: "기타", check: false },
        ],
        checkList2: [
          { label: "유기화합물(117종)", check: false },
          { label: "금속류(24종)", check: false },
          { label: "산·알카리류(17종)", check: false },
          { label: "가스상태 물질류(15종)", check: false },
          { label: "기타", check: false },
        ],
        inspectList: [
          {
            id: 1,
            title: "금지표지",
            label: "금지표지",
            check: false,
            list: [
              {
                id: 1,
                col1: 1,
                col2: "출입금지",
                label: "출입을 통제해야 할 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 2,
                col1: 2,
                col2: "사용금지",
                label: "수리 또는 고장등으로 접촉하거나 작동을 금지해야 할 기계ㆍ기구 및 설비",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 3,
                col1: 3,
                col2: "화기금지",
                label: "화재 발생 염려가 있는 장소로서 화기 취급을 금지하는 장소",
                isTitle: false,
                is_checked: "",
              },
            ],
          },
          {
            id: 2,
            title: "경고표지",
            label: "경고표지",
            check: false,
            list: [
              {
                id: 1,
                col1: 1,
                col2: "인화성 물질 경고",
                label: "휘발유 등 화기 취급을 극히 주의하여야 하는 물질이 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 2,
                col1: 2,
                col2: "고압전기 경고",
                label: "발전소나 고전압이 흐르는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 3,
                col1: 3,
                col2: "매달린 물체 경고",
                label: "돌이나 블록 등 떨어질 우려가 있는 물체가 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 4,
                col1: 4,
                col2: "고온 경고",
                label: "고도의 열을 발하는 물체 또는 온도가 아주 높은 장소",
                isTitle: false,
                is_checked: "",
              },
            ],
          },
          {
            id: 3,
            title: "지시표지",
            label: "지시표지",
            check: false,
            list: [
              {
                id: 1,
                col1: 1,
                col2: "보안경 착용",
                label: "보안경을 착용해야만 작업 또는 출입을 할 수 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 2,
                col1: 2,
                col2: "방독마스크 착용",
                label: "방독마스크를 착용해야만 작업 또는 출입을 할 수 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 3,
                col1: 3,
                col2: "방진마스크 착용",
                label: "방진마스크를 착용해야만 작업 또는 출입을 할 수 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 4,
                col1: 4,
                col2: "보안면 착용",
                label: "보안면을 착용해야만 작업 또는 출입을 할 수 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 5,
                col1: 5,
                col2: "안전모 착용",
                label: "안전모를 착용해야만 작업 또는 출입을 할 수 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 6,
                col1: 6,
                col2: "귀마개 착용",
                label: "소음장소 등 귀마개를 착용해야만 작업 또는 출입을 할 수 잇는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 7,
                col1: 7,
                col2: "안전화 착용",
                label: "안전화를 착용해야만 작업 또는 출입을 할 수 있는 장소",
                isTitle: false,
                is_checked: "",
              },
            ],
          },
          {
            id: 4,
            title: "안내표지",
            label: "안내표지",
            check: false,
            list: [
              {
                id: 1,
                col1: 1,
                col2: "응급구호 표지",
                label: "응급구호설비가 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 2,
                col1: 2,
                col2: "세안장치",
                label: "세안장치가 있는 장소",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 3,
                col1: 3,
                col2: "비상구",
                label: "비상출입구",
                isTitle: false,
                is_checked: "",
              },
            ],
          },
          {
            id: 5,
            title: "관계자 외 출입금지",
            label: "관계자 외 출입금지",
            check: false,
            list: [
              {
                id: 1,
                col1: 1,
                col2: "석면 취급 및 해체ㆍ제거(공사 시)",
                label: "석면 제조, 사용, 해체ㆍ제거 작업장(공사 시)",
                isTitle: false,
                is_checked: "",
              },
              {
                id: 2,
                col1: 2,
                col2: "금지유해물질 취급",
                label: "금지유해물질 제조ㆍ사용설비가 설치된 장소",
                isTitle: false,
                is_checked: "",
              },
            ],
          },
        ],

        inputA_1: "",
        sign1: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
    checkForm() {
      // this.form.typeTitleList = [];
      // for (const data of this.form.inspectList) {
      //   if (data.check) {
      //     this.form.typeTitleList.push(data.label);
      //   }
      // }
    },
    updateListCheck(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text;
    },
    updateListNote(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].note = text;
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  td {
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  .title {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    color: #2c2c2c;
    border: none;
    border-right: 1px solid #cdcdcd;
  }
  .signTitle {
    width: 125px;
    height: 38px;
  }
  .signBody {
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.titleCell {
  border-top: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
}
</style>
